import { createFileRoute } from "@tanstack/react-router";
import SaintForClinicians from "@/pages/saint-for-clinicians/SaintForClinicians";
import { pageSchema } from "@/pages/saint-for-clinicians/clinicianData";

export const Route = createFileRoute("/saint-for-clinicians")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® for Clinicians: Referral Guide, Candidacy & Outcomes",
        },
        {
          name: "description",
          content:
            "For psychiatrists, therapists and PCPs: SAINT® evidence, candidacy criteria, the referral process, and how we coordinate care back to you in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "SAINT® for Clinicians: Referral Guide, Candidacy & Outcomes",
        },
        {
          property: "og:description",
          content:
            "For psychiatrists, therapists and PCPs: SAINT® evidence, candidacy criteria, the referral process, and how we coordinate care back to you in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-for-clinicians",
        },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-for-clinicians",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageSchema),
        },
      ],
    };
  },
});

function RouteComponent() {
  return <SaintForClinicians />;
}
